/**
 * Serializes Office.js edits so Word.run / context.sync never overlap — the Word
 * JavaScript API rejects concurrent Word.run calls, so every document mutation
 * (reads and writes alike) is chained through a single promise queue.
 */ let editChain = Promise.resolve();
export const READ_TIMEOUT_MS = 90_000;
const withTimeout = (work, timeoutMs)=>timeoutMs === Infinity ? work : Promise.race([
        work,
        new Promise((_, reject)=>setTimeout(()=>reject(new Error(`Word did not respond within ${timeoutMs / 1000} s`)), timeoutMs))
    ]);
/**
 * Writes never time out: releasing the queue mid-write would interleave syncs. Reads pass
 * READ_TIMEOUT_MS, so a Word call that never settles fails and frees the queue.
 */ export function runInEditQueue(task, timeoutMs = Infinity) {
    const next = editChain.then(()=>withTimeout(task(), timeoutMs));
    editChain = next.then(()=>undefined, ()=>undefined);
    return next;
}
